import { Skeleton } from "antd";

export default function CertificateInfoLoading() {
  return (
    <div className="p-6 bg-gradient-to-r from-gray-800 to-green-500 rounded-lg flex flex-col md:flex-row items-center gap-4">
      <div className="flex-1 space-y-3 w-full">
        <Skeleton.Input
          active
          className="!h-7 !w-72"
          style={{ backgroundColor: "rgba(255, 255, 255, 0.2)" }}
        />
        <Skeleton
          active
          paragraph={{ rows: 2, width: ["100%", "95%"] }}
          title={false}
          className="[&_.ant-skeleton-paragraph>li]:!bg-white/20"
        />
      </div>
      <Skeleton.Image active className="md:!w-52 md:!h-36 !w-full rounded-lg" />
    </div>
  );
}
